export const marvels = [
  "Angel",
  "AntMan",
  "Barracuda",
  "Beast",
  "BlackWidow",
  "Blade",
  "Blink",
  "Cable",
  "Cloak",
  "Colossus",
  "Cypher",
  "Deadpool",
  "Domino",
  "Electro",
  "Elektra",
  "Falcon",
  "Firestar",
  "Gambit",
  "Havok",
  "Hercules",
  "Hulk",
  "Iceman",
  "IronFist",
  "IronMan",
  "Jubilee",
  "Justice",
  "Lizard",
  "Loki",
  "Madrox",
  "Mimic",
  "Moonstar",
  "Nova",
  "Polaris",
  "Pyro",
  "Quasar",
  "Rhino",
  "Rogue",
  "Sandman",
  "Scorpion",
  "Sentry",
  "Songbird",
  "Spectrum",
  "SpiderGirl",
  "SpiderMan",
  "Stingray",
  "Storm",
  "StrongGuy",
  "Thanos",
  "Thing",
  "Thor",
  "Tigra",
  "Ultron",
  "Venom",
  "Vision",
  "Vulcan",
  "Warriors",
  "Wasp",
  "Wolverine"
];
